import { LicenseFeature, LicensePlan, LicenseCategory } from '../types/license';

export const mergeFeatures = (
  baseFeatures: LicenseFeature[],
  includedFeatures: Partial<Record<string, boolean | string>>
): LicenseFeature[] => {
  return baseFeatures.map(feature => {
    const override = includedFeatures[feature.name];
    const included =
      override === undefined
        ? feature.included
        : typeof override === 'string'
          ? true
          : override;

    return {
      ...feature,
      included,
      additionalInfo:
        typeof override === 'string' ? override : feature.additionalInfo,
    };
  });
};

export const combineFeatureSets = (...featureSets: LicenseFeature[][]): LicenseFeature[] => {
  const combined = new Map<string, LicenseFeature>();
  
  featureSets.forEach(set => {
    set.forEach(feature => {
      if (!combined.has(feature.name)) {
        combined.set(feature.name, feature);
      }
    });
  });
  
  return Array.from(combined.values());
};

export const filterPlansByCategory = (plans: LicensePlan[], category: LicenseCategory): LicensePlan[] => {
  return plans.filter(plan => {
    switch (category) {
      case 'Microsoft 365 Government':
        return ['GCC', 'GCC High', 'DoD'].some(term => plan.name.includes(term));
      case 'Microsoft 365 Business':
        return plan.id.startsWith('m365-business');
      case 'Microsoft 365 Enterprise':
        return plan.id === 'm365-copilot' || /^m365-e[357]/.test(plan.id);
      case 'Microsoft 365 Frontline':
        return plan.id.startsWith('m365-f');
      case 'Microsoft 365 Education':
        return plan.name.includes('Education') || plan.name.includes('A1') || plan.name.includes('A3') || plan.name.includes('A5');
      case 'Office 365':
        return plan.name.includes('Office 365');
      default:
        return false;
    }
  });
};
